import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { fetchQRs } from '../actions/qrs'

import QRList from '../components/QRList'
import ErrorMessage from '../components/ErrorMessage'
import LoadingProgress from '../components/LoadingProgress'

import "../styles/QRsAdminView.css"

class QRsView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {

    }

  }

  componentDidMount() {
    this.props.fetchQRs()
  }

  componentDidUpdate(prevProps) {
    if (this.props.qrsNeedRefresh && !prevProps.qrsNeedRefresh) {
      this.props.fetchQRs()
    }
  }

  render() {
    const { role, type, qrs, error } = this.props

    if (error) {
      return (<ErrorMessage message={error.message} />)
    }

    if (!qrs) {
      return <LoadingProgress />
    }

    return (
      <div className="qrs-admin-view">

        {/* Header (QR-specific styles) */}
        <div className="qrs-admin-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-qrcode mr-3"></i>
                <span className="text-vw-dark mr-1">Parque de</span>
                <span className="text-vw-light">QRs</span>
              </h1>
            </div>

            {role === 'ADMIN' && type === 'MASTER' && (
              <div className="header-actions">
                <Link to="/qrs/add" className="qrs-admin-btn primary">
                  <i className="fas fa-plus"></i>
                  <span>Nuevo</span>
                </Link>
              </div>
            )}
          </div>
        </div>

        <div className="row mb-2">
          <div className="col-12">
            <QRList qrs={qrs} />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  qrs: state.qrs.qrs,
  qrsNeedRefresh: state.qrs.qrsNeedRefresh,
  error: state.qrs.error,
  role: state.auth.role,
  type: state.auth.type
})

const mapDispatchToProps = dispatch => ({
  fetchQRs: bindActionCreators(fetchQRs, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(QRsView)
